/**
 * The record owner's words (SA-1035, spec §6): the one place the strip and
 * the register word who owns a record and how. The owner is a server-resolved
 * name; never render an id (SA-330).
 */
import type { OwnerBasis } from '@/types/commerce'

export const OWNER_BASIS_WORDS: Record<OwnerBasis, string> = {
  approved: 'approved the enquiry',
  entered: 'entered the enquiry',
  started: 'started the process',
}

export const NO_OWNER = 'No owner'
export const UNKNOWN_PERSON = 'Unknown person'

/** The queue assignee's tooltip in the register, so the two people on a row
 * are never confused. */
export function assignedToTitle(name: string): string {
  return `Assigned to ${name}`
}
